import { clientPlatformEnv } from '@/utils/runtimes'
import type { Router } from 'vue-router'

export function createRouterGuards(router: Router) {
  router.beforeEach(async (_to, _from, next) => {
    // fix IOS wechat history
    if (clientPlatformEnv.isIOS && clientPlatformEnv.isWechat) {
      window.history.replaceState(null, '', window.location.href)
    }

    next()
  })
}
